import { Outlet } from "react-router";

import { AuthorizationFallback } from "~/base";
import { Authorization, HASURA_EDITOR_ROLES } from "./authorization";

/** These screens require fields absent from Hasura's viewer schema. */
export function HasuraEditorOutlet() {
  return (
    <Authorization allowedRoles={HASURA_EDITOR_ROLES} forbiddenFallback={<AuthorizationFallback />}>
      <Outlet />
    </Authorization>
  );
}
